export default __webpack_public_path__ + "static/shape_square_male-726574f51da186103e6255c33bb48ab8.png";